import { Injectable,Inject } from '@angular/core';
import { UUID } from 'angular2-uuid';

@Injectable()
export class UniqueIdService {

  constructor() { }

  generate() : string {
    // for now we return nothing.
    return UUID.UUID();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/unique-id.service.ts